import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEraserSimple: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="eraser-simple, rubber, clean-up"><path d="M11.5979 4.34103C13.0624 2.87656 15.4367 2.87656 16.9012 4.34103L19.6586 7.09839C21.123 8.56285 21.123 10.9372 19.6586 12.4017L14.5602 17.5L6.49955 9.43938L11.5979 4.34103Z" fill="currentColor"/><path d="M5.43889 10.5L4.34054 11.5984C2.87607 13.0629 2.87607 15.4372 4.34054 16.9017L7.0979 19.659C8.56236 21.1235 10.9367 21.1235 12.4012 19.659L13.4995 18.5607L5.43889 10.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconEraserSimple;
